<template>
  <div
    class="create-folder-modal"
    :class="{ success: collectionCreated }"
  >
    <div class="create-folder-modal__upper-container">
      <svgicon
        :name="icon"
        original
        class="create-folder-modal__icon"
      />
      <template v-if="collectionCreated">
        <p
          class="create-folder-modal__title"
        >
          Recept har lagts till i {{ folderName }}
        </p>
      </template>
    </div>
    <div
      v-if="!collectionCreated"
      class="create-folder-modal__container"
    >
      <ica-input-text
        ref="create-folder-input"
        v-model="folderName"
        class="create-folder-modal__input"
        aria-label="Namn på receptsamlingen"
        label="Namn på receptsamlingen"
        placeholder="Namn på receptsamlingen"
        maxlength="50"
        name="createFolder"
        :validation-delay="0"
        :disabled="isLoading"
        :custom-validate-func="validator"
        @keyup-enter="onEnter"
      />

      <ica-notification
        v-if="showErrorMessage"
        :closeable="false"
        :active="true"
        message="Just nu går det inte att skapa foldrar. Försök igen senare."
        type="Error"
        class="create-folder-modal__error-notification"
      />
      <div class="create-folder-modal__button-container">
        <button
          class="button button--48 button--white button--fullwidth"
          @click="closeModal"
        >
          Avbryt
        </button>
        <button
          class="button button--48 button--fullwidth"
          :disabled="invalidName || isLoading"
          @click="saveNewCollection"
        >
          Skapa
        </button>
      </div>
    </div>

    <div
      v-else
      class="create-folder-modal__created"
    >
      <div class="create-folder-modal__button-container success">
        <button
          class="button button--48 button--white button--fullwidth"
          @click="toCollection"
        >
          Till receptsamlingen
        </button>
        <button
          class="button button--48 button--fullwidth"
          @click="closeModal"
        >
          Klar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import '#/Illustrative/RecipeCollection'
import '#/Illustrative/Checkmark'
import { IcaNotification, IcaInputText }  from '~/@ica/ica-molecules-vue/src/components'
import svgicon from "vue-svgicon"

export default {
  name: 'CreateFolderModalContent',
  components: {
    IcaInputText,
    IcaNotification,
    svgicon,
  },
  props: {
    folderId: {
      type: Number,
      default: null,
    },
    recipeId: {
      type: Number,
      default: null,
    },
    collectionCreated: {
      type: Boolean,
      default: false,
    },
    showErrorMessage: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      folderName: '',
      isLoading: false,
    }
  },
  computed: {
    icon () {
      if (this.collectionCreated) {
        return 'Illustrative/Checkmark'
      } else {
        return 'Illustrative/RecipeCollection'
      }
    },
    invalidName () {
      return /^\s*$/.test(this.folderName) // checks if user has only entered whitespace
    },
  },
  methods: {
    saveNewCollection () {
      this.isLoading = true
      this.$emit('save-new-collection', this.folderName)
      // if OK
      this.isLoading = false
    },
    onEnter () {
      if (!this.isLoading && this.folderName) {
        this.saveNewCollection()
      }
    },
    toCollection () {
      this.$emit('route-to-collection', this.folderName)
      this.closeModal()
    },
    closeModal () {
      this.$emit('close-modal')
    },
    validator (text) {
      const nameIsWhiteSpaceOnly = /^\s*$/.test(text)
      return !nameIsWhiteSpaceOnly
    },
  },
}
</script>

<style lang="scss">
.create-folder-modal {
  background: $color-orange-lightest;
  text-align: center;
  border-radius: 0.25rem;
  height: 100%;
  padding: 1.5rem 2rem 1.5rem;

  @include media-breakpoint-up(md) {
    padding: 3rem 4rem 3rem;
  }

  &.success {
    background: $color-green-lightest;
    padding: 3rem 2rem 2rem;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @include media-breakpoint-up(md) {
      padding: 3rem 4rem 3rem;
      display: block;
    }
  }

  &__error-notification {
    margin-bottom: 1rem;
  }

  &__icon {
    width: 6.5rem;
    height: 6.5rem;

    @include media-breakpoint-up(md) {
      width: 8.5rem;
      height: 8.5rem;
    }
  }

  &__title {
    @include font(rubrik, 3, bold);

    margin: 1.5rem 0 2rem;

    @include media-breakpoint-up(md) {
      margin: 2rem 0 2rem;
    }
  }

  &__input {
    margin-bottom: 2rem;
  }

  &__container {
    margin: 2rem auto 0;

    @include media-breakpoint-up(md) {
      margin: 3rem auto 0;
    }
  }

  &__button-container {
    display: flex;
    flex-direction: column-reverse;
    margin: 0 auto;

    button {
      &:last-child {
        margin-bottom: 0.5rem;
      }
    }

    @include media-breakpoint-up(md) {
      flex-direction: row;
      align-items: center;

      button {
        &:first-child {
          margin-right: 1rem;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
